<form
    [formGroup]="editform"
    autocomplete="off"
    (ngSubmit)="editform.valid && saveFn()"
>
    <div class="conn-card p-flud">
        <div class="stripe-guidance" *ngIf="!isNew">
            <div class="stripe-guidance-header">
                <i class="pi pi-info-circle"></i>
                <span>Stripe coupon edit guidance</span>
            </div>
            <div class="stripe-guidance-body">
                Stripe only allows updating limited fields on existing coupons (like name/metadata).
                For changes to discount amount, duration, or redemption rules, create a new coupon.
            </div>
            <button
                type="button"
                pButton
                class="p-button-sm p-button-outlined"
                label="Create new coupon instead"
                (click)="startCreateNewCoupon()"
            ></button>
        </div>
        
        <!-- 1️⃣ Basic Coupon Info -->
        <div class="grid py-1">
            <div class="col-12 md:col-12 lg:col-12">
                <label class="control-label"
                    ><strong
                        >Coupon Name <span class="text-danger">*</span></strong
                    ></label
                >
                <app-text-input
                    [formControl]="$any(editform.controls)['discountName']"
                    [name]="'Coupon Name'"
                    [label]="''"
                    placeholder="Enter coupon name"
                    [ngClass]="{
                        'p-invalid':
                            f.discountName?.touched && f.discountName?.invalid
                    }"
                ></app-text-input>
            </div>

            <div class="col-12 md:col-6 lg:col-6 hidden">
                <label class="control-label"
                    ><strong
                        >Discount Type
                        <span class="text-danger">*</span></strong
                    ></label
                >
                <p-dropdown
                    [formControl]="$any(editform.controls)['discountValueType']"
                    [options]="discountTypeList"
                    optionLabel="viewValue"
                    class="w-full mt-2"
                ></p-dropdown>
            </div>

            <div
                class="col-12 md:col-6 lg:col-6"
                *ngIf="
                    f.discountValueType?.value?.id !== 2 &&
                    f.discountValueType?.value?.id !== 3
                "
            >
                <label class="control-label"
                    ><strong
                        >Value <span class="text-danger">*</span></strong
                    ></label
                >
                <app-text-input
                    [formControl]="$any(editform.controls)['discountValue']"
                    [name]="'Value'"
                    [label]="''"
                ></app-text-input>
                <small
                    class="text-danger"
                    *ngIf="
                        editform
                            .get('discountValue')
                            .hasError('maxFractionalDigits')
                    "
                >
                    Maximum 2 fractional digits allowed.
                </small>
            </div>
        </div>

        <!-- 2️⃣ Max Discount / Validity -->
        <div class="grid py-1" *ngIf="f.discountValueType?.value?.id != 2">
            <div
                class="col-12 md:col-6 lg:col-6"
                *ngIf="f.discountValueType?.value?.id == 1"
            >
                <label class="control-label"
                    ><strong>Max Discount ($)</strong></label
                >
                <app-text-input
                    [formControl]="$any(editform.controls)['maximumAllowed']"
                    [name]="'Max Discount'"
                    [label]="''"
                ></app-text-input>
            </div>

            <div
                class="col-12 md:col-6 lg:col-6"
                *ngIf="f.discountValueType?.value?.id !== 2"
            >
                <label class="control-label"
                    ><strong>Max Coupon Use</strong></label
                >
                <app-text-input
                    [formControl]="$any(editform.controls)['maxCouponUse']"
                    [name]="'Max Coupon Use'"
                    [label]="''"
                ></app-text-input>
            </div>

            <div
                class="col-12 md:col-6 lg:col-6"
                *ngIf="f.discountValueType?.value?.id !== 2"
            >
                <label class="control-label"><strong>Validity</strong></label>
                <p-dropdown
                    [formControl]="$any(editform.controls)['validity']"
                    [options]="validityList"
                    optionLabel="viewValue"
                    class="w-full"
                ></p-dropdown>
            </div>
        </div>

        <!-- 3️⃣ Date Range + Allowed Days -->
        <div class="grid py-1" *ngIf="f.discountValueType?.value?.id != 2">
            <div
                class="col-12 md:col-6"
                *ngIf="
                    f.validity?.value?.id == 1 &&
                    f.discountValueType?.value?.id !== 2
                "
            >
                <label class="control-label"><strong>Date Range</strong></label>
                <p-calendar
                    [formControl]="$any(editform.controls)['validityDate']"
                    selectionMode="range"
                    appendTo="body"
                    class="w-full"
                ></p-calendar>
            </div>

            <!-- <div
                class="col-12 md:col-6"
                *ngIf="f.discountValueType?.value?.id !== 2"
            >
                <label class="control-label"
                    ><strong>Allowed Days</strong></label
                >
                <p-multiselect
                    [formControl]="$any(editform.controls)['allowedDaysList']"
                    [options]="allowedDaysList"
                    optionLabel="viewValue"
                    [showToggleAll]="true"
                    class="w-full"
                >
                    <ng-template pTemplate="header">
                        <div class="checkbox-all-text">Select All</div>
                    </ng-template>
                </p-multiselect>
            </div> -->
        </div>

        <!-- 4️⃣ Subscription Section -->
        <div class="grid py-1" *ngIf="f.discountValueType?.value?.id == 3">
            <div class="col-12 md:col-6 lg:col-3">
                <label class="control-label"
                    ><strong
                        >Subscription Plan
                        <span class="text-danger">*</span></strong
                    ></label
                >
                <p-dropdown
                    [formControl]="
                        $any(editform.controls)['allowedLocationsList']
                    "
                    [options]="allowedLocationsList"
                    optionLabel="viewValue"
                    placeholder="Select Plan"
                    [showClear]="true"
                    class="w-full"
                    [disabled]="!allowedLocationsList.length"
                    [ngClass]="{
                        'p-invalid':
                            f.allowedLocationsList.invalid &&
                            f.allowedLocationsList.touched
                    }"
                ></p-dropdown>
                <small
                    class="p-error"
                    *ngIf="
                        f.allowedLocationsList.invalid &&
                        f.allowedLocationsList.touched
                    "
                >
                    Subscription Plan is required.
                </small>
            </div>

            <div
                class="col-12 md:col-3 lg:col-3"
                *ngIf="f.discountValueType?.value?.id == 3"
            >
                <label class="control-label"
                    ><strong
                        >Discounted Price ($)
                        <span class="text-danger">*</span></strong
                    ></label
                >
                <app-text-input
                    [ngClass]="{
                        'p-invalid':
                            f.discountedPrice?.touched &&
                            f.discountedPrice?.invalid
                    }"
                    [formControl]="$any(editform.controls)['discountedPrice']"
                    [name]="'Discounted Price'"
                ></app-text-input>
                <div *ngIf="f.allowedLocationsList?.value" class="my-2">
                    <div class="text-600 font-medium mb-1">
                        Subscription Price:
                    </div>

                    <div class="flex align-items-center gap-2">
                        <p-badge
                            *ngIf="f.allowedLocationsList?.value?.monthlyPrice"
                            [value]="
                                f.allowedLocationsList?.value?.monthlyPrice +
                                ' USD / month'
                            "
                            severity="info"
                        >
                        </p-badge>

                        <p-badge
                            *ngIf="f.allowedLocationsList?.value?.yearlyPrice"
                            [value]="
                                f.allowedLocationsList?.value?.yearlyPrice +
                                ' USD / year'
                            "
                            severity="success"
                        >
                        </p-badge>
                    </div>
                </div>

                <div
                    *ngIf="
                        $any(editform.controls)['discountedPrice'].hasError(
                            'subscriptionDiscountInvalid'
                        )
                    "
                >
                    <small class="p-error">
                        Discounted price must be lower than monthly or yearly
                        subscription price.
                    </small>
                </div>
            </div>

            <div
                class="col-12 md:col-3 lg:col-2"
                *ngIf="f.discountValueType?.value?.id == 3"
            >
                <label class="control-label"
                    ><strong
                        >Validity <span class="text-danger">*</span></strong
                    ></label
                >
                <p-dropdown
                    [formControl]="
                        $any(editform.controls)['subscriptionValidity']
                    "
                    [options]="subscriptionValidityList"
                    optionLabel="viewValue"
                    placeholder="Select"
                    class="w-full"
                ></p-dropdown>
            </div>

            <div
                class="col-12 md:col-3 lg:col-2"
                *ngIf="
                    f.subscriptionValidity?.value?.id === 2 &&
                    f.discountValueType?.value?.id == 3
                "
            >
                <label class="control-label"
                    ><strong
                        >Months <span class="text-danger">*</span></strong
                    ></label
                >
                <app-text-input
                    [formControl]="$any(editform.controls)['monthsCount']"
                    [name]="'Months'"
                ></app-text-input>
            </div>

            <div
                class="col-12 md:col-3 lg:col-2"
                *ngIf="f.discountValueType?.value?.id == 3"
            >
                <label class="control-label"
                    ><strong
                        >Interval <span class="text-danger">*</span></strong
                    ></label
                >
                <p-dropdown
                    [formControl]="$any(editform.controls)['billingInterval']"
                    [options]="billingIntervalList"
                    optionLabel="viewValue"
                    placeholder="Select"
                    class="w-full"
                ></p-dropdown>
            </div>
        </div>

        <!-- 5️⃣ Coupon Codes -->
        <div class="grid py-1">
            <div class="col-12 md:col-6">
                <label class="control-label"
                    ><strong
                        >Coupon Codes <span class="text-danger">*</span></strong
                    ></label
                >
                <p-chips
                    type="text"
                    [formControl]="$any(editform.controls)['couponCodesList']"
                    separator=","
                    addOnBlur="true"
                    [allowDuplicate]="false"
                    [max]="1"
                ></p-chips>
                <span class="control-description text-muted">
                    <u>Instructions:</u>
                    <li>One code for one coupon only.</li>
                    <li>Coupon code must not contain special characters.</li>
                    <li>
                        Please use minimum 4 and maximum 10 alphanumeric
                        characters only.
                    </li>
                    <!-- One code for one coupon only.Coupon code must not contain special characters. Please use minimum 4 and maximum 10 alphanumeric characters only. -->
                </span>
                <!-- <span class="control-description text-muted" >One code for one coupon only.(Max code characters allowed = 10, i.e., AbC%123456)</span> -->
                <div *ngIf="$any(editform.controls)['couponCodesList'].touched">
                    <div
                        *ngIf="
                            $any(editform.controls)['couponCodesList'].invalid
                        "
                        class="invalid-feedback"
                    >
                        Please enter a Code
                    </div>
                </div>
            </div>
            <div class="col-12 md:col-6">
                <label class="control-label"><strong>Status</strong></label>
                <p-dropdown
                    [formControl]="$any(editform.controls)['isActive']"
                    [options]="statusList"
                    optionLabel="viewValue"
                    class="w-full"
                ></p-dropdown>
            </div>

            <div
                class="col-12 md:col-12"
                *ngIf="
                    ($any(editform.controls)['couponCodesList'].valid &&
                        f.allowedLocationsList.valid) ||
                    isViewOnly
                "
            >
                <div class="field mb-3">
                    <label
                        class="control-label font-medium text-gray-700"
                        *ngIf="f.discountValueType?.value?.id != 3"
                    >
                        <strong>
                            Base URL <span class="text-danger">*</span>
                        </strong>
                    </label>
                    <label
                        class="control-label font-medium text-gray-700"
                        *ngIf="f.discountValueType?.value?.id == 3"
                    >
                        <strong>
                            Promotion URL
                            <i
                                class="pi pi-copy cursor-pointer text-primary absolute right-3 top-3 py-1 px-2 rounded hover:bg-gray-200"
                                title="Copy link"
                                (click)="copy(genratedLink)"
                            ></i>
                        </strong>
                    </label>

                    <div
                        class="relative"
                        *ngIf="f.discountValueType?.value?.id != 3"
                    >
                        <input
                            pInputText
                            type="text"
                            class="w-full text-gray-800 bg-gray-50 border rounded-lg p-2"
                            [formControl]="f.printText"
                            placeholder="Enter or confirm your base URL"
                            [ngClass]="{
                                'p-invalid':
                                    f.printText.invalid && f.printText.touched
                            }"
                        />

                        <!-- ✅ Copy icon (tooltip feedback optional) -->
                        <i
                            class="pi pi-copy cursor-pointer text-primary absolute right-3 top-3 py-1 px-2 rounded hover:bg-gray-200"
                            title="Copy link"
                            (click)="copy(genratedLink)"
                        ></i>
                    </div>

                    <!-- 🧠 Helper text -->
                    <small
                        class="text-gray-500 block mt-1"
                        *ngIf="f.discountValueType?.value?.id != 3"
                    >
                        Default: <code>https://app.lincsell.com</code> for
                        subscription, <code>https://lincsell.com</code> for
                        others.
                    </small>

                    <!-- 🧠 Validation messages -->
                    <small
                        class="p-error block"
                        *ngIf="
                            f.printText.touched &&
                            f.printText.hasError('required')
                        "
                    >
                        Base URL is required.
                    </small>

                    <small
                        class="p-error block"
                        *ngIf="
                            f.printText.touched &&
                            f.printText.hasError('pattern')
                        "
                    >
                        Please enter a valid URL (e.g.
                        https://app.lincsell.com).
                    </small>

                    <!-- ✅ Generated link -->
                    <div
                        *ngIf="
                            (f.printText.valid && genratedLink) || isViewOnly
                        "
                        class="mt-2 text-sm px-2 py-1 bg-gray-100 rounded-lg"
                    >
                        <a
                            [href]="genratedLink"
                            target="_blank"
                            class="text-primary hover:underline break-all"
                        >
                            {{ genratedLink }}
                        </a>
                    </div>
                </div>

                <!-- <label class="control-label"
                    ><strong
                        >Base URL <span class="text-danger">*</span></strong
                    ></label
                >

                <app-text-input
                    [formControl]="$any(editform.controls)['printText']"
                    [name]="'Url'"
                    [ngClass]="{
                        'p-invalid': f.printText.touched && f.printText.invalid
                    }"
                ></app-text-input> -->

                <!-- 🧠 Validation messages -->
                <!-- <small
                    class="p-error"
                    *ngIf="
                        f.printText.touched && f.printText.hasError('required')
                    "
                >
                    URL is required.
                </small> -->

                <!-- <small
                    class="p-error"
                    *ngIf="
                        f.printText.touched && f.printText.hasError('pattern')
                    "
                >
                    Please enter a valid URL (e.g., https://app.lincsell.com).
                </small> -->

                <!-- ✅ Show generated link only when valid -->
                <!-- <div *ngIf="f.printText.valid && genratedLink" class="mt-2">
                    <span class="control-description text-muted">
                        {{ genratedLink }}
                    </span>
                    &nbsp;
                    <i
                        class="pi pi-copy cursor-pointer text-primary"
                        (click)="copy(genratedLink)"
                    ></i>
                </div> -->
            </div>
        </div>

        <p-divider></p-divider>
        <!-- 🧠 Debug: show full form structure -->
        <!-- <pre class="bg-gray-100 text-sm p-3 mt-3 border-round" style="max-height: 300px; overflow: auto;">
  {{ editform.value | json }}
</pre> -->

        <!-- 🧩 Show validation status and errors -->
        <!--<pre
            class="bg-yellow-50 text-xs p-2 mt-2 border-round"
            style="max-height: 250px; overflow: auto"
        >
  Status: {{ editform.status }}
  Errors: {{ editform.errors | json }}
  Controls:
  {{ getFormErrors(editform) | json }}
</pre>  -->
        <!-- Buttons -->
        <div class="flex justify-start" *ngIf="errorMessage">
            <p class="text-red-500 text-md font-medium">
                {{ errorMessage }}
            </p>
        </div>
        <div class="flex justify-content-end gap-2 mt-3">
            <button
                pButton
                pRipple
                type="submit"
                label="Save"
                [disabled]="!editform.valid"
                *ngIf="!isViewOnly"
                class="p-button-success"
            ></button>
            <button
                pButton
                pRipple
                type="button"
                label="Cancel"
                class="p-button-outlined p-button-danger"
                (click)="cancelButtonClick()"
            ></button>
        </div>
    </div>
</form>
